import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

export const useUserStore = create(
  persist(
    (set) => ({
      userStore: null,
      setUserStore: (userStore) => set({ userStore: userStore }),
    }),
    {
      name: "user-storage",
      storage: createJSONStorage(() => {
        if (typeof window !== "undefined") {
          return localStorage;
        }
        return {
           getItem: () => null,
           setItem: () => {},
           removeItem: () => {},
        };
      }),
    }
  )
);
